const INFO_RSA = "Information sur le Rsa";
const AIDE_UTILISATION_SITE = "Aide à l'utilisation du site (Hotline)";
const PRIME_ACTIVITE = "Prime d'activité";
const DEPOT_RECLAMATION = "Dépôt d'une réclamation";
const AU_SUJET_DE = "Au sujet de";
const VOTRE_DOSSIER = "--- Votre dossier ---";
const DROITS_PRESTATIONS = "--- Vos droits aux prestations ---";
const INFO_ALLOC_ENFANTS = "Informations sur les allocations pour les enfants";
const ETUDIANT_APL = "Étudiant – aides personnelles au logement";
const ALLOC_ENFANTS = "Allocations pour les enfants"
const INFOS_APL = "Informations sur les aides personnelles au logement";
const INFO_PA = "Information sur la prime d'activité";
const APL = "Aides personnelles au logement";
const INFO_AIDES_HANDICAP = "Je m'informe sur les aides handicap/proche aidant";
const AIDES_HANDICAP = "Aides handicap/proche aidant";
const OUPS = "Oups ! j'ai fait une erreur, que faire ?";
const DEMANDE_ATTESTATION_PAIEMENT = "Demande d'attestation de paiement";
const CONTESTER = "Contester un droit, un paiement ou un indu";
const VOTRE_CAF = "--- Votre Caf ---";
const DEMANDE_INFO = "Demande d'information sur les points d'accueil et les modes de contacts";
const ACCUEIL_ET_MODE_CONTACT = "Accueil et modes de contacts";
const DEMANDE_INFO_APL_ETUDIANT = "Étudiant – Demande d'information aides personnelles au logement";
const DEMANDE_INFO_ACTU_CAF = "Demande d'information sur le fonctionnement ou l'actualité de votre Caf";
const ACTU_CAF = "Actualité de votre Caf";
const UTILISATION_SITE_CAF = "--- L'utilisation du site ---";
const RECLAM = "--- Réclamations ---";
const TRAITEMENT_DOSSIER = "--- le traitement de votre dossier ---";
const SERVICE_CAF = "--- les services de votre Caf ---";
const AUTRE = "Autre";
const AIDE_LOGEMENT = "Aides au logement";
const RSA = "Rsa";
const AAH = "Aah";
const AVVC = "Informations sur l'aide d'urgence pour les victimes de violences conjugales"

export const LIBELLE_FORMULAIRE: { [key: string]: any[] } = {
    listeObjetMessage: [{
        "libelleCaffr": DROITS_PRESTATIONS,
        "libelleMobile": DROITS_PRESTATIONS,
        "selectionnable": false,
        "code": "INFO_SEP_PRE",
        "statSid": ""
    }, {
        "libelleCaffr": INFO_ALLOC_ENFANTS,
        "libelleMobile": ALLOC_ENFANTS,
        "selectionnable": true,
        "code": "INFO_ALF",
        "statSid": "DIAENTENFWEB",
        "cleRnProduit": "RN_PRODUCT_122"
    }, {
        "libelleCaffr": DEMANDE_INFO_APL_ETUDIANT,
        "libelleMobile": ETUDIANT_APL,
        "selectionnable": true,
        "code": "INFO_ETU",
        "statSid": "DIAENTETULOGWEB",
        "cleRnProduit": "RN_PRODUCT_118"
    }, {
        "libelleCaffr": INFOS_APL,
        "libelleMobile": APL,
        "selectionnable": true,
        "code": "INFO_APL",
        "statSid": "DIAENTLOGWEB",
        "cleRnProduit": "RN_PRODUCT_121"
    }, {
        "libelleCaffr": INFO_RSA,
        "libelleMobile": INFO_RSA,
        "selectionnable": true,
        "code": "INFO_RSA",
        "statSid": "DIAENTRSAWEB",
        "cleRnProduit": "RN_PRODUCT_119"
    }, {
        "libelleCaffr": INFO_PA,
        "libelleMobile": PRIME_ACTIVITE,
        "selectionnable": true,
        "code": "INFO_PPA",
        "statSid": "DIAENTPPAWEB",
        "cleRnProduit": "RN_PRODUCT_117"
    },
    {
        "libelleCaffr": AVVC,
        "libelleMobile": AVVC,
        "selectionnable": true,
        "code": "INFO_AUT",
        "statSid": "",
        "cleRnProduit": "RN_PRODUCT_566",
    },
    {
        "libelleCaffr": INFO_AIDES_HANDICAP,
        "libelleMobile": AIDES_HANDICAP,
        "selectionnable": true,
        "code": "INFO_AAH",
        "statSid": "DIAENTHANWEB",
        "cleRnProduit": "RN_PRODUCT_120",
    },
    {
        "libelleCaffr": VOTRE_DOSSIER,
        "libelleMobile": VOTRE_DOSSIER,
        "selectionnable": false,
        "code": "INFO_SEP_DOS",
        "statSid": ""
    }, {
        "libelleCaffr": "Question sur le suivi de votre dossier",
        "libelleMobile": "Suivi de votre dossier",
        "selectionnable": true,
        "code": "INFO_DOS",
        "statSid": "DIAENTDOSWEB",
        "cleRnProduit": "RN_PRODUCT_125"
    }, {
        "libelleCaffr": "Question suite à une déclaration de changement de situation",
        "libelleMobile": "Suivi d'un changement de situation",
        "selectionnable": true,
        "code": "INFO_CHT",
        "statSid": "DIAENTCHASITWEB",
        "cleRnProduit": "RN_PRODUCT_113"
    }, {
        "libelleCaffr": OUPS,
        "libelleMobile": OUPS,
        "selectionnable": true,
        "code": "INFO_ERR",
        "statSid": "DIAENTOUPSWEB",
        "cleRnProduit": "RN_PRODUCT_299"
    }, {
        "libelleCaffr": DEMANDE_ATTESTATION_PAIEMENT,
        "libelleMobile": DEMANDE_ATTESTATION_PAIEMENT,
        "selectionnable": true,
        "code": "INFO_ATT",
        "statSid": "DIAENTATTPAIWEB",
        "cleRnProduit": "RN_PRODUCT_114"
    }, {
        "libelleCaffr": CONTESTER,
        "libelleMobile": CONTESTER,
        "selectionnable": true,
        "code": "INFO_PAI",
        "statSid": "DIAENTCONTWEB",
        "cleRnProduit": "RN_PRODUCT_112"
    }, {
        "libelleCaffr": "Question sur vos remboursements/retenues. Demande de remise de dettes ou un échéancier",
        "libelleMobile": "Vos remboursements/retenues remise de dettes",
        "selectionnable": true,
        "code": "INFO_CRE",
        "statSid": "DIAENTREMBWEB",
        "cleRnProduit": "RN_PRODUCT_124"
    }, {
        "libelleCaffr": VOTRE_CAF,
        "libelleMobile": VOTRE_CAF,
        "selectionnable": false,
        "code": "INFO_SEP_CAF",
        "statSid": ""
    }, {
        "libelleCaffr": DEMANDE_INFO,
        "libelleMobile": ACCUEIL_ET_MODE_CONTACT,
        "selectionnable": true,
        "code": "INFO_ACC",
        "statSid": "DIAENTCONTAWEB",
        "cleRnProduit": "RN_PRODUCT_116"
    }, {
        "libelleCaffr": DEMANDE_INFO_ACTU_CAF,
        "libelleMobile": ACTU_CAF,
        "selectionnable": true,
        "code": "INFO_CAF",
        "statSid": "DIAENTACTUWEB",
        "cleRnProduit": "RN_PRODUCT_115"
    }, {
        "libelleCaffr": UTILISATION_SITE_CAF,
        "libelleMobile": UTILISATION_SITE_CAF,
        "selectionnable": false,
        "code": "INFO_SEP_SIT",
        "statSid": ""
    }, {
        "libelleCaffr": AIDE_UTILISATION_SITE,
        "libelleMobile": AIDE_UTILISATION_SITE,
        "selectionnable": true,
        "code": "INFO_SIT",
        "statSid": "DIAENTAIDEWEB",
        "cleRnProduit": "RN_PRODUCT_110"
    }, {
        "libelleCaffr": RECLAM,
        "libelleMobile": RECLAM,
        "selectionnable": false,
        "code": "INFO_SEP_REC",
        "statSid": ""
    }, {
        "libelleCaffr": DEPOT_RECLAMATION,
        "libelleMobile": DEPOT_RECLAMATION,
        "selectionnable": true,
        "code": "INFO_REC",
        "statSid": "DIAENTRECLAMWEB",
        "cleRnProduit": "RN_PRODUCT_123",
    }
    ],
    listeObjetMessagePrimo: [{
        "libelleCaffr": INFO_ALLOC_ENFANTS,
        "libelleMobile": ALLOC_ENFANTS,
        "selectionnable": true,
        "code": "INFO_ALF",
        "statSid": "DIAENTENFWEB",
        "cleRnProduit": "RN_PRODUCT_122"
    }, {
        "libelleCaffr": DEMANDE_INFO_APL_ETUDIANT,
        "libelleMobile": ETUDIANT_APL,
        "selectionnable": true,
        "code": "INFO_ETU",
        "statSid": "DIAENTETULOGWEB",
        "cleRnProduit": "RN_PRODUCT_118"
    }, {
        "libelleCaffr": INFOS_APL,
        "libelleMobile": APL,
        "selectionnable": true,
        "code": "INFO_APL",
        "statSid": "DIAENTLOGWEB",
        "cleRnProduit": "RN_PRODUCT_121"
    }, {
        "libelleCaffr": INFO_RSA,
        "libelleMobile": INFO_RSA,
        "selectionnable": true,
        "code": "INFO_RSA",
        "statSid": "DIAENTRSAWEB",
        "cleRnProduit": "RN_PRODUCT_119"
    }, {
        "libelleCaffr": INFO_PA,
        "libelleMobile": PRIME_ACTIVITE,
        "selectionnable": true,
        "code": "INFO_PPA",
        "statSid": "DIAENTPPAWEB",
        "cleRnProduit": "RN_PRODUCT_117"
    }, {
        "libelleCaffr": INFO_AIDES_HANDICAP,
        "libelleMobile": AIDES_HANDICAP,
        "selectionnable": true,
        "code": "INFO_AAH",
        "statSid": "DIAENTHANWEB",
        "cleRnProduit": "RN_PRODUCT_120"
    }, {
        "libelleCaffr": DEMANDE_INFO,
        "libelleMobile": ACCUEIL_ET_MODE_CONTACT,
        "selectionnable": true,
        "code": "INFO_ACC",
        "statSid": "DIAENTCONTAWEB",
        "cleRnProduit": "RN_PRODUCT_116"
    }, {
        "libelleCaffr": DEMANDE_INFO_ACTU_CAF,
        "libelleMobile": ACTU_CAF,
        "selectionnable": true,
        "code": "INFO_CAF",
        "statSid": "DIAENTACTUWEB",
        "cleRnProduit": "RN_PRODUCT_115"
    },
    {
        "libelleCaffr": AVVC,
        "libelleMobile": AVVC,
        "selectionnable": true,
        "code": "INFO_AUT",
        "statSid": "",
        "cleRnProduit": "RN_PRODUCT_566",
    },
    {
        "libelleCaffr": AIDE_UTILISATION_SITE,
        "libelleMobile": AIDE_UTILISATION_SITE,
        "selectionnable": true,
        "code": "INFO_SIT",
        "statSid": "DIAENTAIDEWEB",
        "cleRnProduit": "RN_PRODUCT_110"
    }, {
        "libelleCaffr": DEPOT_RECLAMATION,
        "libelleMobile": DEPOT_RECLAMATION,
        "selectionnable": true,
        "code": "INFO_REC",
        "statSid": "DIAENTRECLAMWEB",
        "cleRnProduit": "RN_PRODUCT_123"
    }],
    listeMotifReclamation: [{
        "libelleCaffr": TRAITEMENT_DOSSIER,
        "libelleMobile": TRAITEMENT_DOSSIER,
        "selectionnable": false,
        "famille": "separateur",
        "code": "RECL_SEP_DOS"
    }, {
        "libelleCaffr": "Vous n'avez pas  reçu votre paiement",
        "libelleMobile": "Paiement non reçu",
        "selectionnable": true,
        "famille": "dossier",
        "code": "RECL_PAI"
    }, {
        "libelleCaffr": "Vous n'avez pas eu de réponse à votre demande",
        "libelleMobile": "Demande sans réponse",
        "selectionnable": true,
        "famille": "dossier",
        "code": "RECL_DEM"
    }, {
        "libelleCaffr": "Les documents transmis n'ont pas été pris ou mal en compte",
        "libelleMobile": "Documents transmis non/mal pris en compte",
        "selectionnable": true,
        "famille": "dossier",
        "code": "RECL_DOC"
    }, {
        "libelleCaffr": "Vous ne comprenez pas la décision de la Caf",
        "libelleMobile": "Incompréhension décision Caf",
        "selectionnable": true,
        "famille": "dossier",
        "code": "RECL_CAF"
    }, {
        "libelleCaffr": "Vous ne comprenez pas votre trop perçu ou les modalités de remboursement",
        "libelleMobile": "Incompréhension trop perçu/modalités remboursement",
        "selectionnable": true,
        "famille": "dossier",
        "code": "RECL_CRE"
    }, {
        "libelleCaffr": SERVICE_CAF,
        "libelleMobile": SERVICE_CAF,
        "selectionnable": false,
        "famille": "separateur",
        "code": "RECL_SEP_CAF"
    }, {
        "libelleCaffr": "Vous n'êtes pas satisfait des conditions d'accueil (espace d'accueil, attente, borne, ...)",
        "libelleMobile": "Insatisfactions conditions d'accueil (espace, borne, ...)",
        "selectionnable": true,
        "famille": "caf",
        "code": "RECL_INS"
    }, {
        "libelleCaffr": "Vous avez des difficultés à joindre la Caf au téléphone",
        "libelleMobile": "Difficultés à joindre la Caf au téléphone",
        "selectionnable": true,
        "famille": "caf",
        "code": "RECL_TEL"
    }, {
        "libelleCaffr": "Vous n'êtes pas satisfait du site Caf.fr (simulations, télé procédures, informations, fonctionnement ...)",
        "libelleMobile": "Insatisfactions site Caf.fr",
        "selectionnable": true,
        "famille": "caf",
        "code": "RECL_SIT"
    }, {
        "libelleCaffr": "Vous n'êtes pas satisfait de l'accueil du personnel",
        "libelleMobile": "Insatisfactions de l'accueil du personnel",
        "selectionnable": true,
        "famille": "caf",
        "code": "RECL_ACC"
    }, {
        "libelleCaffr": AUTRE,
        "libelleMobile": AUTRE,
        "selectionnable": true,
        "famille": "caf",
        "code": "RECL_AUT"
    }],
    listePrestation: [{
        "libelleCaffr": AIDE_LOGEMENT,
        "libelleMobile": AIDE_LOGEMENT,
        "selectionnable": true,
        "code": "PRES_APL"
    }, {
        "libelleCaffr": RSA,
        "libelleMobile": RSA,
        "selectionnable": true,
        "code": "PRES_RSA"
    }, {
        "libelleCaffr": PRIME_ACTIVITE,
        "libelleMobile": PRIME_ACTIVITE,
        "selectionnable": true,
        "code": "PRES_PPA"
    }, {
        "libelleCaffr": AAH,
        "libelleMobile": AAH,
        "selectionnable": true,
        "code": "PRES_AAH"
    }, {
        "libelleCaffr": "PAJE/ Compléments de mode de garde",
        "libelleMobile": "PAJE/ Mode de garde",
        "selectionnable": true,
        "code": "PRES_PAJ"
    }, {
        "libelleCaffr": "Allocations familiales/ Complément familial",
        "libelleMobile": "Alloc. familiales/Complément familial",
        "selectionnable": true,
        "code": "PRES_ALF"
    }, {
        "libelleCaffr": "Allocation de rentrée scolaire",
        "libelleMobile": "Ars",
        "selectionnable": true,
        "code": "PRES_ARS"
    }, {
        "libelleCaffr": "Allocation journalière de présence parentale",
        "libelleMobile": "Alloc. présence parentale",
        "selectionnable": true,
        "code": "PRES_AJP"
    }, {
        "libelleCaffr": "Allocation de soutien familial",
        "libelleMobile": "Alloc. soutien familial",
        "selectionnable": true,
        "code": "PRES_ASF"
    }, {
        "libelleCaffr": "Allocation d'éducation de l'enfant handicapé",
        "libelleMobile": "Alloc. Handicap enfant",
        "selectionnable": true,
        "code": "PRES_AEH"
    }, {
        "libelleCaffr": "Allocation vieillesse du parent au foyer",
        "libelleMobile": "Alloc. vieillesse parent au foyer",
        "selectionnable": true,
        "code": "PRES_AVP"
    }, {
        "libelleCaffr": "Prime de déménagement",
        "libelleMobile": "Prime déménagement",
        "selectionnable": true,
        "code": "PRES_PPD"
    }],
    listePjSitPro: [{
        "idCas": "301",
        "codeOrigine": "41040"
    }, {
        "idCas": "302",
        "codeOrigine": "14003"
    }, {
        "idCas": "311",
        "codeOrigine": "31010"
    }, {
        "idCas": "47",
        "codeOrigine": "32020"
    }, {
        "idCas": "303",
        "codeOrigine": "42032"
    }, {
        "idCas": "304",
        "codeOrigine": "82010"
    }, {
        "idCas": "77",
        "codeOrigine": "42100"
    }, {
        "idCas": "305",
        "codeOrigine": "31039"
    }, {
        "idCas": "306",
        "codeOrigine": "20510"
    }, {
        "idCas": "307",
        "codeOrigine": "10409"
    }],
    listePjSitFam: [{
        "idCas": "308",
        "codeOrigine": "20108"
    }, {
        "idCas": "309",
        "codeOrigine": "21100"
    }, {
        "idCas": "310",
        "codeOrigine": "20200"
    }, {
        "idCas": "312",
        "codeOrigine": "42060"
    }, {
        "idCas": "313",
        "codeOrigine": "42070"
    }, {
        "idCas": "314",
        "codeOrigine": "20300"
    }, {
        "idCas": "306",
        "codeOrigine": "20510"
    }, {
        "idCas": "315",
        "codeOrigine": "20800"
    }, {
        "idCas": "305",
        "codeOrigine": "31039"
    }, {
        "idCas": "307",
        "codeOrigine": "10409"
    }],
    listePjLogement: [{
        "idCas": "316",
        "codeOrigine": "50081"
    }, {
        "idCas": "317",
        "codeOrigine": "50140"
    }, {
        "idCas": "318",
        "codeOrigine": "20509"
    }, {
        "idCas": "319",
        "codeOrigine": "50020"
    }, {
        "idCas": "53",
        "codeOrigine": "50200"
    }, {
        "idCas": "320",
        "codeOrigine": "50220"
    }, {
        "idCas": "321",
        "codeOrigine": "50060"
    }, {
        "idCas": "306",
        "codeOrigine": "20510"
    }, {
        "idCas": "307",
        "codeOrigine": "10409"
    }],
    listePjFormCaf: [{
        "idCas": "58",
        "codeOrigine": "11731"
    }, {
        "idCas": "60",
        "codeOrigine": "11000"
    }, {
        "idCas": "322",
        "codeOrigine": "60952"
    }, {
        "idCas": "323",
        "codeOrigine": "10200"
    }, {
        "idCas": "63",
        "codeOrigine": "20220"
    }, {
        "idCas": "324",
        "codeOrigine": "20121"
    }, {
        "idCas": "71",
        "codeOrigine": "10900"
    }, {
        "idCas": "325",
        "codeOrigine": "11450"
    }, {
        "idCas": "54",
        "codeOrigine": "11400"
    }, {
        "idCas": "326",
        "codeOrigine": "31029"
    }, {
        "idCas": "53",
        "codeOrigine": "50200"
    }]
};

export const LIBELLE_EVENT_CAMILLE: { [key: string]: string } = {
    envoi: "postCourriel",
    envoiOk: "courrielOk",
    envoiKo: "courrielKo",
    reset: "resetMotif"
};

export const LIBELLE_STAT: { [key: string]: string } = {
    libelleContacterMaCaf: "contacter_ma_caf",
    libelleParCourriel: "par_courriel",
    libelleReponse: "contact_caf_reponses",
    libelleEnvoi: "contact_caf_envoi_courriel",
    libelleEnvoiPrimo: "contactcafprimo_contact_caf_envoi_courriel",
    libelleImprimer: "imprimer_satisfait",
    libelleSurRendezVous: "sur_rendez_vous"
};

export const ETAT_CAMILLE: { [key: string]: string } = {
    erreur: "error",
    resultatsOk: "reponses",
    resultatsVide: "resultatsVide"
};

export const REGEX_COURRIEL: { [key: string]: RegExp } = {
    value: /[\u0000-\u0008\u000B\u000C\u000E-\u001F\u007F-\u009F]/g,
    backupValue: /[\x00-\x1F\x7F-\x9F]/g
};

export const LIBELLE_MOTIF: string[] = [
    "Votre situation",
    "Votre demande",
    AU_SUJET_DE,
    AU_SUJET_DE,
    AU_SUJET_DE
];
